import React from 'react'
import Heading from 'src/components/Heading'
import RichText from 'src/utils/RichText'
import Button from 'src/components/Button'
import GetAny from 'src/utils/GetAny'
import FluidImage from 'src/utils/FluidImage'
import ContentLabel from 'src/components/ContentLabel'
import ShortenText from 'src/utils/ShortenText'
import SbEditable from 'storyblok-react'

const FourByTwoGridOnBrandV1 = ({ blok }) => {
    return(
        <SbEditable content={blok} key={blok._uid}>
            <section className={`${blok.grey_bg ? "bg-midgrey py-16 sm:pt-20 sm:pb-24 lg:pt-24" : "bg-white my-16 sm:mt-20 sm:mb-24 lg:mt-24"}`}>
                <div className="lg:max-w-7xl max-w-4xl mx-auto">
                    <div className="px-6 relative">
                        <div className="flex lg:flex-row flex-col pb-5 border-b border-gray-100 lg:gap-0 gap-6">
                            <div>
                                <Heading size="h2" colour="darkgrey">{blok.title}</Heading>
                                <div className="prose font-body text-sm">
                                    <RichText>{blok.description}</RichText>
                                </div>
                            </div>
                                {
                                    blok.button_target.cached_url &&
                                    <div className="lg:ml-auto self-end">
                                        <Button className="bg-red hover:bg-darkred" target={`/${blok.button_target.cached_url}`}>{blok.button_text}</Button>
                                    </div>
                                }
                            </div>
                        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 py-12">
                            {
                                GetAny(blok.items).map((item, index) => (
                                    <a className="flex flex-col cursor-pointer relative" key={index} href={`/${item.full_slug}`}>
                                        <div className="absolute left-0 top-0 z-10">
                                            <ContentLabel type={item.content.component} />
                                        </div>
                                        <div className="relative z-1 cursor-pointer hover:opacity-70 duration-300 block">
                                            <FluidImage className="mb-3" image={item.content.thumbnail_image} width="500" height="500"/>
                                        </div>
                                        <Heading size="h4" colour="darkgrey">{item.name}</Heading>
                                        <p className="text-sm text-darkgrey prose font-body">
                                            <RichText>{ShortenText(item.content.meta?.description || 'Description not available', 280)}</RichText>
                                        </p>
                                    </a>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
        </SbEditable>
    )
}

export default FourByTwoGridOnBrandV1